function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { su, theme } from '@arc/frontend/ui-theme';
const getBadgeColors = (color, backgroundColor, textColor) => {
  if (backgroundColor && textColor) {
    return {
      backgroundColor,
      textColor
    };
  }
  switch (color) {
    case 'error':
      {
        return {
          backgroundColor: '#ff4444',
          textColor: '#ffffff'
        };
      }
    case 'warning':
      {
        return {
          backgroundColor: '#ffaa00',
          textColor: '#444'
        };
      }
    case 'success':
      {
        return {
          backgroundColor: '#44ff44',
          textColor: '#000000'
        };
      }
    default:
      {
        return {
          backgroundColor: theme.colors.palettes.primary.main,
          textColor: theme.colors.palettes.primary.contrastText
        };
      }
  }
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "5tpiub",
  styles: "position:relative;display:inline-flex"
} : {
  name: "1gkqrzp-badgeStyles",
  styles: "position:relative;display:inline-flex;label:badgeStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function Badge({
  count = 0,
  children,
  color = 'error',
  max = 99,
  showZero = false,
  variant = 'standard',
  backgroundColor,
  textColor
}) {
  const shouldShow = count > 0 || count === 0 && showZero;
  const displayCount = count > max ? `${max}+` : count.toString();
  const colors = getBadgeColors(color, backgroundColor, textColor);
  const badgeStyles = _ref;
  const badgeContent = /*#__PURE__*/css(su.roundedFull, {
    position: 'absolute',
    top: -6,
    right: -18,
    minWidth: variant === 'dot' ? 8 : 16,
    height: variant === 'dot' ? 8 : 16,
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.backgroundColor,
    color: colors.textColor,
    padding: variant === 'standard' ? '0 4px' : 0,
    zIndex: 1,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)'
  }, process.env.NODE_ENV === "production" ? "" : ";label:badgeContent;");
  return <span css={badgeStyles}>
			{children}
			{shouldShow ? <span css={badgeContent} data-testid="badge">
					{variant === 'standard' ? displayCount : ''}
				</span> : null}
		</span>;
}